/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../../styles/components/pageComponents/dashboard/ActionItems.module.css';

interface ActionItemsProps {
	title?: string;
	children: React.ReactNode; // This will render any child components (your cards)
	className?: string;
}

const ActionItems: React.FC<ActionItemsProps> = ({
	title,
	children,
	className,
}) => {
	return (
		<section className={className}>
			<span className={styles.sectionTitle}>{title}</span>
			<div className={styles.grid}>{children}</div>
		</section>
	);
};

export default ActionItems;
